import { z } from 'zod';

export const exportProfilesQuerySchema = z
  .object({
    startNumericalId: z.coerce.number().int().min(0).optional().default(0),
    createdAtFrom: z.coerce.date().optional(),
    createdAtTo: z.coerce.date().optional(),
    lastVisitFrom: z.coerce.date().optional(),
    lastVisitTo: z.coerce.date().optional(),
    updatedAtFrom: z.coerce.date().optional(),
    updatedAtTo: z.coerce.date().optional(),
    levelIds: z
      .preprocess(val => {
        if (val === undefined) return undefined;
        if (typeof val === 'string') {
          if (val.trim() === '') return [];
          return [val];
        }
        return val;
      }, z.array(z.string().uuid()))
      .optional(), // undefined = no level filter, empty array = only members with no level
  })
  .refine(
    data =>
      data.createdAtFrom !== undefined ||
      data.lastVisitFrom !== undefined ||
      data.updatedAtFrom !== undefined,
    {
      message: 'At least one of createdAtFrom, lastVisitFrom or updatedAtFrom is required',
      path: ['createdAtFrom'],
    },
  );

export type ExportProfilesQuery = z.infer<typeof exportProfilesQuerySchema>;
